import { render, staticRenderFns } from "./MediaDetail.vue?vue&type=template&id=2978d978&scoped=true"
import script from "./MediaDetail.vue?vue&type=script&lang=js"
export * from "./MediaDetail.vue?vue&type=script&lang=js"
import style0 from "./MediaDetail.vue?vue&type=style&index=0&id=2978d978&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2978d978",
  null
  
)

export default component.exports